export default "__VITE_ASSET__4ae0b933__"